import { Config3d } from '@ff-scene-plugins/gift-shared/GiftVariantOptions';
import { ArConfig } from 'ff-preview-3d';

export const toArConfig = (config3d: Config3d): ArConfig => {
    return {
        placementMode: config3d.arPlacement ?? 'floor',
        normalMapUrl: config3d.normalMapUrl,
        environmentHdrUrl: config3d.environmentHdrUrl
    };
};